import React, { useEffect, useState } from "react";
import { Header, DefaultSideBar, Button } from "components";
import TableOnBoard from "components/TableOnBoard";
import { useNavigate } from "react-router-dom";
import { listDataOnboard } from "services/onboard";

// Halaman OnBoardPage
export default function OnBoardPage() {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  const fetchData = async () => {
    setLoading(true);
    const res = await listDataOnboard();
    setData(res.data?.companies ?? []);
    setLoading(false);
  };

  useEffect(() => {
    fetchData();
  }, []);

  const createOnBoard = () => {
    navigate("/create-on-board");
    return;
  };
  return (
    <div className="w-full relative bg-gray-100 pl-[81px] pt-[10vh]">
      <Header />
      <DefaultSideBar />
      {!loading ? (
        <div className="flex flex-col items-start justify-start w-full mt-5 gap-[17px] px-10">
          {/* Tombol Create On Board */}
          <div className="flex justify-end w-full">
            <Button
              color="yellow_800"
              size="md"
              className="font-bold min-w-[150px]"
              onClick={() => createOnBoard()}
            >
              Onboard Issuer
            </Button>
          </div>

          {/* Tabel OnBoard */}
          <TableOnBoard data={data} />
        </div>
      ) : (
        <div className="flex w-full h-[90vh] justify-center items-center">
          Loading...
        </div>
      )}
    </div>
  );
}
